import GroupsIndexingGrid from './groups-indexing-grid';

export default function GroupsIndexingPage() {
  return <GroupsIndexingGrid />;
}
